module.exports = __webpack_public_path__ + "img/95c4198.jpg";